/**
 * Step2 字段配置：维度 / 指标类型与 i18n 映射、下拉值规范化。
 * 与 Cube 文档中维度 type 白名单保持一致。
 */

/** Cube 维度 `type` 下拉顺序及白名单；旧数据 `date` 在控件上映射为 `time` */
export const DIM_DATA_TYPES = [
  'string',
  'number',
  'time',
  'boolean',
  'geo',
  // 'switch',
];

/** 指标聚合类型（`default_type`）可选值 */
export const MEAS_DATA_TYPES = [
  'sum',
  'count',
  'count_distinct',
  'avg',
  'min',
  'max',
  'number',
];

/**
 * 将任意字符串规范为维度下拉可选值：`date` → `time`，未知 → `string`。
 */
export const coerceDimTypeSelectValue = (raw: string | undefined): string => {
  const v = (raw || 'string').trim();
  if (v === 'date') {
    return 'time';
  }
  return (DIM_DATA_TYPES as readonly string[]).includes(v) ? v : 'string';
};

/** 维度 `type` → `modelManagement` 文案 id（字段配置 · 维度数据类型） */
export const DIM_TYPE_ID: Record<string, string> = {
  time: 'dbl_model_agent_field_config_dim_data_type_time',
  string: 'dbl_model_agent_field_config_dim_data_type_string',
  number: 'dbl_model_agent_field_config_dim_data_type_number',
  boolean: 'dbl_model_agent_field_config_dim_data_type_boolean',
  geo: 'dbl_model_agent_field_config_dim_data_type_geo',
  switch: 'dbl_model_agent_field_config_dim_data_type_switch',
};

/** 指标 `default_type` → 文案 id（字段配置 · 指标聚合方式） */
export const MEAS_TYPE_ID: Record<string, string> = {
  sum: 'dbl_model_agent_field_config_measure_agg_sum',
  count: 'dbl_model_agent_field_config_measure_agg_count',
  count_distinct:
    'dbl_model_agent_field_config_measure_agg_count_distinct',
  avg: 'dbl_model_agent_field_config_measure_agg_avg',
  min: 'dbl_model_agent_field_config_measure_agg_min',
  max: 'dbl_model_agent_field_config_measure_agg_max',
  number: 'dbl_model_agent_field_config_measure_agg_number',
};
